import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {EnvironmentService} from '../../core/services/environment.service';

@Component({
  selector: 'app-cash-robot',
  templateUrl: './cash-robot.component.html',
  styleUrls: ['./cash-robot.component.scss']
})
export class CashRobotComponent implements OnInit {

  @Output() changeMethod = new EventEmitter();

  constructor(public readonly environmentService: EnvironmentService) { }

  ngOnInit() {
  }

  handleChangeMethod() {
    this.changeMethod.emit();
  }

}
